import React from 'react';
import PropTypes from 'prop-types';
import {
  Field,
  InnerLabel,
  ValidationErrorMessage,
  Body,
  Box,
} from '@edreamsodigeo/prisma-design-system';
import { Desktop, Mobile, useTranslation } from '@edreamsodigeo/frontend-core';

const SuggestionTxt = ({ focused, htmlFor }) => {
  const id = htmlFor.replace(/_/, '');
  const { t } = useTranslation();

  if (id === 'name' || id === 'surname') {
    return null;
  }
  return focused ? (
    <Box pl="base" position="absolute">
      <Body type="xSmall" weight="normal" color="neutral.80">
        {t(`pricefreeze.form.passenger.helpmessage.${id}`)}
      </Body>
    </Box>
  ) : null;
};

const ValidationErrorKey = ({ focused, htmlFor }) => {
  const { t } = useTranslation();
  const id = htmlFor.replace(/_/, '');
  return !focused ? (
    <Box pl="base" position="absolute">
      <Body type="xSmall">
        {t(`pricefreeze.form.passenger.errorMandatory.${id}`)}
      </Body>
    </Box>
  ) : null;
};

const ValidationErrorKeyIRUM = ({ focused, htmlFor }) => {
  const { t } = useTranslation();
  const id = htmlFor.replace(/_/, '');
  return !focused ? (
    <Box pl="base" position="absolute">
      <Body type="xSmall">
        {t(`pricefreeze.form.passenger.summaryErrorMandatory.${id}`)}
      </Body>
    </Box>
  ) : null;
};

export const ValidationErrorKeyVariationPhase2 = ValidationErrorKey;

export const FormFieldWrapper = ({
  label,
  children,
  fieldProps,
  labelProps,
  validationProps,
}) => {
  return (
    <Box position="relative">
      <Field {...fieldProps}>
        <InnerLabel {...labelProps}>{label}</InnerLabel>
        {children}
      </Field>

      <ValidationErrorMessage style={{ padding: 0 }} {...validationProps}>
        <Mobile>
          <ValidationErrorKeyVariationPhase2
            focused={fieldProps?.focus}
            htmlFor={labelProps?.htmlFor}
          />
        </Mobile>
        <Desktop>
          <ValidationErrorKeyIRUM
            focused={fieldProps?.focus}
            htmlFor={labelProps?.htmlFor}
          />
        </Desktop>
      </ValidationErrorMessage>
      <SuggestionTxt
        focused={fieldProps?.focus}
        htmlFor={labelProps?.htmlFor}
      ></SuggestionTxt>
    </Box>
  );
};

FormFieldWrapper.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  fieldProps: PropTypes.object.isRequired,
  labelProps: PropTypes.object.isRequired,
  validationProps: PropTypes.object.isRequired,
};
